import React, { useRef, useState } from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import { Button } from '@/Components/ui/button'
import { useLoaderData, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import Loader from '@/Components/Common/Loader'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import { Checkbox } from '@/Components/ui/checkbox'
import { Textarea } from '@/Components/ui/textarea'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/Components/ui/table'
import NoDataFound from '@/Components/Common/NoDataFound'
import MitemService from '@/Service/MitemService'

const CreateMitem = () => {
    const formRef = useRef(null)
    const pick_lists = [
        {
            pick_list: 'SinglePickList',
        },
        { pick_list: 'MultiplePickList' },
        { pick_list: 'DatePicker' },
        { pick_list: 'Text' },
        { pick_list: 'Number' },
    ]

    const { sectionData, mitemPayorType, assessmentType } = useLoaderData()
   
    const [isSaving, setIsSaving] = useState(false)
    const formSchema = z.object({
        mitem: z.string().min(1, {
            message: 'mitem is required',
        }),
        section: z.string().min(1, {
            message: 'section is required',
        }),
        parent_mitem: z.string().optional(),
        enable: z.boolean().default(false).optional(),
        questions: z.string().optional(),
        character_length: z.string().optional(),
        pick_list: z.string().optional(),
    })
    const [response, setResponse] = useState([])
    const [functionality, setFunctionality] = useState([])
    const [checkRes, setcheckRes] = useState(false)
    const [checkFun, setcheckFun] = useState(false)
    const [isenable,setIsenable]=useState(false);

    const navigate = useNavigate()
    const form = useForm({
        shouldFocusError: false,
        resolver: zodResolver(formSchema),
        defaultValues: {
            mitem: '',
            parent_mitem: '',
            section: '',
            enable: isenable,
            questions: '',
            character_length: '',
            pick_list: '',
            response: response,
            client: functionality,
        },
    })

    async function onSubmit(values) {
        console.log('values', values)
        console.log('functionality', functionality, 'response', response)
        values['client'] = functionality
        values['response'] = response
        try {
            setIsSaving(true)
            const resp = await MitemService.createMitem(values)
            if (resp.data.success) {
                setIsSaving(false)
                navigate(`/setup/mitem/${resp.data.data.name}`)
            }
        } catch (err) {
            setIsSaving(false)
        }
    }

    function onError(errors, e) {
        const errorKeys = Object.keys(errors)
        console.log('in error', errorKeys[0])
        if (errorKeys.length > 0 && errors[errorKeys[0]]?.message) {
            toast.error(errors[errorKeys[0]].message)
        } else {
            toast.error('Something went wrong.')
        }
    }

    const handleSaveClick = () => {
        if (formRef.current) {
            formRef.current.requestSubmit()
        }
    }

    const deleteresone = (action) => {
        if (!action) {
            setDeleteConfirmationOpen(false)
            return false
        }
        const updatedrows = response.filter((row) => !row.checkbox)
        let newdata = updatedrows.length > 0 ? updatedrows : []
        setResponse(() => newdata)
        setDeleteConfirmationOpen(false)
    }
    const deleteresAll = (action) => {
        if (!action) {
            setDeleteConfirmationOpen(false)
            return false
        }
        setResponse([])
        setcheckRes(false)
        setDeleteConfirmationOpen(false)
    }

    const changeresOne = (row, index) => {
        setResponse((prev) => {
            let updatedData = []

            prev.map((item, i) => {
                if (index == i) {
                    prev[i]['checkbox'] = !prev[i]['checkbox']
                }
                updatedData.push(item)
            })
            return updatedData
        })
    }

    const changeresAll = () => {
        let isChecked = !checkRes
        setcheckRes((prev) => isChecked)

        setResponse((prev) => {
            let updatedData = []

            prev.map((item, i) => {
                prev[i]['checkbox'] = isChecked
                updatedData.push(item)
            })

            return updatedData
        })
    }

    const addResponse = () => {
        setResponse((prev) => {
            const newId = prev.length > 0 ? prev[prev.length - 1].id + 1 : 1
            return [
                ...prev,
                {
                    id: newId,
                    checkbox: false,
                    response: '',
                },
            ]
        })
    }

    const deletefunone = (action) => {
        if (!action) {
            setDeleteConfirmationOpen(false)
            return false
        }
        const updatedrows = functionality.filter((row) => !row.checkbox)
        let newdata = updatedrows.length > 0 ? updatedrows : []
        setFunctionality(() => newdata)
        setDeleteConfirmationOpen(false)
    }
    const deletefunAll = (action) => {
        if (!action) {
            setDeleteConfirmationOpen(false)
            return false
        }
        setFunctionality([])
        setcheckFun(false)
        setDeleteConfirmationOpen(false)
    }

    const changefunOne = (row, index) => {
        setFunctionality((prev) => {
            let updatedData = []

            prev.map((item, i) => {
                if (index == i) {
                    prev[i]['checkbox'] = !prev[i]['checkbox']
                }
                updatedData.push(item)
            })
            return updatedData
        })
    }

    const changefunAll = () => {
        let isChecked = !checkFun
        setcheckFun((prev) => isChecked)

        setFunctionality((prev) => {
            let updatedData = []

            prev.map((item, i) => {
                prev[i]['checkbox'] = isChecked
                updatedData.push(item)
            })

            return updatedData
        })
    }

    const addFunctionality = () => {
        console.log('in add functionality')
        setFunctionality((prev) => {
            const newId = prev.length > 0 ? prev[prev.length - 1].id + 1 : 1
            return [
                ...prev,
                {
                    id: newId,
                    checkbox: false,
                    mitem_payor_type: '',
                    assessmentType: '',
                    enable: isenable,
                },
            ]
        })
    }

    return (
        <>
            <HeaderCard>
                <div className="flex justify-end items-center">
                    <div className="flex items-center justify-end gap-2">
                        <Button
                            className="bg-primary-purpal hover:bg-primary-purpal px-4"
                            onClick={handleSaveClick}
                            iconType="Save"
                            disabled={isSaving}
                        >
                            Save {isSaving && <Loader fullScreen={false} />}
                        </Button>
                    </div>
                </div>
            </HeaderCard>
            <BodyCard>
                <Form {...form}>
                    <form ref={formRef} onSubmit={form.handleSubmit(onSubmit, onError)} className="">
                        <div className="grid grid-cols-2 gap-y-3 gap-x-6">
                            <FormField
                                control={form.control}
                                name="mitem"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>Mitem</FormLabel>
                                        <FormControl>
                                            <Input
                                                className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                placeholder="Mitem"
                                                {...field}
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />

                            <FormField
                                control={form.control}
                                name="parent_mitem"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel>Parent Mitem</FormLabel>
                                        <FormControl>
                                            <Input
                                                className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                placeholder="Parent Mitem"
                                                {...field}
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                            <FormField
                                control={form.control}
                                name="section"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>Section</FormLabel>
                                        <FormControl>
                                            <SearchableDropdown
                                                options={sectionData}
                                                selectedVal={field.value.name}
                                                handleChange={(val) => {
                                                    setIsenable(()=>val.enable)
                                                    field.onChange(val)}}
                                                placeholder="Select Section"
                                                label="section_name"
                                                type="GET_OBJ"
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />

                            <FormField
                                control={form.control}
                                name="enable"
                                render={({ field }) => (
                                    <FormItem className="flex flex-row items-start space-x-3 space-y-1">
                                        <div className="flex justify-start gap-3 items-center mt-8">
                                            <Checkbox checked={field.value} onCheckedChange={field.onChange}  disabled={!isenable&&true}/>
                                            <span className="text-sm">Enable</span>
                                        </div>
                                    </FormItem>
                                )}
                            />
                        </div>

                        <h6 className="mt-5 mb-3 font-bold text-[14px]">Questions Response</h6>
                        <div className="grid grid-cols-2 gap-y-3 gap-x-6">
                            <div>
                                <FormField
                                    control={form.control}
                                    name="questions"
                                    render={({ field }) => (
                                        <FormItem className="space-y-1">
                                            <FormLabel>Questions</FormLabel>
                                            <FormControl>
                                                <Textarea
                                                    placeholder="Questions"
                                                    className="resize-none shadow-none focus-visible:ring-transparent"
                                                    rows="5"
                                                />
                                            </FormControl>
                                        </FormItem>
                                    )}
                                />
                            </div>
                            <div className="gap-y-2 gap-x-6 grid">
                                <FormField
                                    control={form.control}
                                    name="character_length"
                                    render={({ field }) => (
                                        <FormItem className="space-y-1">
                                            <FormLabel>Character Length</FormLabel>
                                            <FormControl>
                                                <Input
                                                    className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                    placeholder="Character length"
                                                    {...field}
                                                />
                                            </FormControl>
                                        </FormItem>
                                    )}
                                />{' '}
                                <FormField
                                    control={form.control}
                                    name="pick_list"
                                    render={({ field }) => (
                                        <FormItem className="space-y-1">
                                            <FormLabel>PickList</FormLabel>
                                            <FormControl>
                                                <SearchableDropdown
                                                    options={pick_lists}
                                                    selectedVal={field.value}
                                                    handleChange={(val) => field.onChange(val)}
                                                    placeholder="Select PickList"
                                                    label="pick_list"
                                                />
                                            </FormControl>
                                        </FormItem>
                                    )}
                                />
                            </div>
                        </div>
                        <h6 className="text-[13px] text-gray-600 font-bold mt-4">Response</h6>

                        <Table className="mt-2">
                            <TableHeader>
                                <TableRow className="border">
                                    <TableHead className="w-[5%] border">
                                        <Checkbox onClick={changeresAll} value={checkRes} checked={checkRes} />
                                    </TableHead>
                                    <TableHead className="w-[50px] border">Sr.No</TableHead>
                                    <TableHead className="w-[300px] border">Response</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {response?.length == 0 ? (
                                    <TableRow className="border">
                                        <TableCell className="border" colSpan="6">
                                            <NoDataFound />
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    response?.map((row, index) => (
                                        <TableRow key={row.index} name="poc" className="border">
                                            <TableCell className="border">
                                                <Checkbox onClick={() => changeresOne(row, index)} checked={row.checkbox} value={row.checkbox} />
                                            </TableCell>
                                            <TableCell className="border">{index + 1}</TableCell>
                                            <TableCell className="border">
                                                <Input
                                                    placeholder="Response"
                                                    defaultValue={row.description_of_service}
                                                    onChange={(event) => {
                                                        setResponse((prev) => {
                                                            let updatedData = []
                                                            prev.map((item, i) => {
                                                                if (item.id == row.id) {
                                                                    prev[i]['response'] = event.target.value
                                                                }
                                                                updatedData.push(item)
                                                            })
                                                            return updatedData
                                                        })
                                                    }}
                                                    className="border-none shadow-none focus-visible:ring-0 focus:border-0 focus:shadow-none focus:border-none"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>

                        <div className="mt-2 flex gap-1">
                            <Button
                                type="button"
                                className=" hover:bg-gray-200 bg-gray-200 border-gray-800 text-gray-600 text-[12px]"
                                onClick={addResponse}
                            >
                                Add Row
                            </Button>

                            {!checkRes && response.filter((row) => row.checkbox).length > 0 ? (
                                <>
                                    <Button type="button" className="bg-primary-red ml-1 font-normal" onClick={deleteresone}>
                                        Delete
                                    </Button>
                                </>
                            ) : null}

                            {checkRes && response.length > 0 && (
                                <>
                                    <Button type="button" className="bg-primary-red ml-1 font-normal" onClick={deleteresAll}>
                                        Delete All
                                    </Button>
                                </>
                            )}
                        </div>

                        <h6 className="text-[13px] text-gray-600 font-bold mt-5">Functionality</h6>

                        <Table className="mt-2">
                            <TableHeader>
                                <TableRow className="border">
                                    <TableHead className="w-[5%] border">
                                        <Checkbox onClick={changefunAll} value={checkFun} checked={checkFun} />
                                    </TableHead>
                                    <TableHead className="w-[50px] border">Sr.No</TableHead>
                                    <TableHead className="w-[300px] border">Payor Type Group</TableHead>
                                    <TableHead className="w-[300px] border">Assessment Type</TableHead>
                                    <TableHead className="w-[300px] border">Enable</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {functionality?.length == 0 ? (
                                    <TableRow className="border">
                                        <TableCell className="border" colSpan="6">
                                            <NoDataFound />
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    functionality?.map((row, index) => (
                                        <TableRow key={row.index} name="poc" className="border">
                                            <TableCell className="border">
                                                <Checkbox onClick={() => changefunOne(row, index)} checked={row.checkbox} value={row.checkbox} />
                                            </TableCell>
                                            <TableCell className="border">{index + 1}</TableCell>
                                            <TableCell className="border">
                                                <SearchableDropdown
                                                    options={mitemPayorType}
                                                    selectedVal={row.mitem_payor_type}
                                                    handleChange={(val) =>
                                                        setFunctionality((prev) => {
                                                            let updatedData = []
                                                            prev.map((item, i) => {
                                                                if (i == index) {
                                                                    prev[i]['mitem_payor_type'] = val
                                                                }
                                                                updatedData.push(item)
                                                            })
                                                            return updatedData
                                                        })
                                                    }
                                                    className="border-none w-full outline-none ring-0 focus-visible:ring-0"
                                                    placeholder="Select Payor Type Group"
                                                    label="mitem_payor_type"
                                                />
                                            </TableCell>
                                            <TableCell className="border">
                                                <SearchableDropdown
                                                    options={assessmentType}
                                                    selectedVal={row.assessment_type}
                                                    handleChange={(val) =>
                                                        setFunctionality((prev) => {
                                                            let updatedData = []
                                                            prev.map((item, i) => {
                                                                if (i == index) {
                                                                    prev[i]['assessment_type'] = val
                                                                }
                                                                updatedData.push(item)
                                                            })
                                                            return updatedData
                                                        })
                                                    }
                                                    className="border-none w-full outline-none ring-0 focus-visible:ring-0"
                                                    placeholder="Select Assessment Type "
                                                    label="assessment_type"
                                                />
                                            </TableCell>
                                            <TableCell className="border">
                                                <Checkbox
                                                    onCheckedChange={(isChecked) => {
                                                        setFunctionality((prev) => {
                                                            let updatedData = []
                                                            prev.map((item, i) => {
                                                                if (i == index) {
                                                                    prev[i]['enable'] = isChecked
                                                                }
                                                                updatedData.push(item)
                                                            })
                                                            return updatedData
                                                        })
                                                    }}
                                                    checked={Boolean(row.enable)}
                                                    value={row.enable}
                                                    disabled={!isenable&&true}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>

                        <div className="mt-2 flex gap-1">
                            <Button
                                type="button"
                                className=" hover:bg-gray-200 bg-gray-200 border-gray-800 text-gray-600 text-[12px]"
                                onClick={addFunctionality}
                            >
                                Add Row
                            </Button>

                            {!checkFun && functionality.filter((row) => row.checkbox).length > 0 ? (
                                <>
                                    <Button type="button" className="bg-primary-red ml-1 font-normal" onClick={deletefunone}>
                                        Delete
                                    </Button>
                                </>
                            ) : null}

                            {checkFun && functionality.length > 0 && (
                                <>
                                    <Button type="button" className="bg-primary-red ml-1 font-normal" onClick={deletefunAll}>
                                        Delete All
                                    </Button>
                                </>
                            )}
                        </div>
                    </form>
                </Form>
            </BodyCard>
        </>
    )
}

export default CreateMitem
